<template>
    <bubble-menu
        v-if="editor"
        :editor="editor"
        :update-delay="100"
        :tippy-options="tippyOptions"
        class="bubble-menu">
        <MenuBarBoldButton v-if="toolbarOptions.includes('bold')" :editor="editor" :disabled="disabled"/>
        <MenuBarItalicButton v-if="toolbarOptions.includes('italic')" :editor="editor" :disabled="disabled"/>
        <MenuBarUnderlineButton v-if="toolbarOptions.includes('underline')" :editor="editor" :disabled="disabled"/>
        <MenuBarStrikeButton v-if="toolbarOptions.includes('strike')" :editor="editor" :disabled="disabled"/>
        <MenuBarLinkButton v-if="toolbarOptions.includes('link')" :editor="editor" :disabled="disabled"/>
        <MenuBarNumberedListButton v-if="toolbarOptions.includes('ordered-list')" :editor="editor" :disabled="disabled"/>
        <MenuBarBulletedListButton v-if="toolbarOptions.includes('bullet-list')" :editor="editor" :disabled="disabled"/>
        <MenuBarColorButton v-if="toolbarOptions.includes('color')" :editor="editor" :disabled="disabled"/>
        <MenuBarHighlightButton v-if="toolbarOptions.includes('highlight')" :editor="editor" :disabled="disabled"/>
        <MenuBarAlignmentButton v-if="hasAlignmentButtons" :editor="editor" :toolbar-options="toolbarOptions" :disabled="disabled"/>
        <MenuBarClearButton v-if="toolbarOptions.includes('clear')" :editor="editor" :disabled="disabled"/>
        <MenuBarSizeButton v-if="toolbarOptions.includes('size')" :editor="editor" :disabled="disabled"/>
    </bubble-menu>
</template>

<script>
import { Editor, BubbleMenu } from '@tiptap/vue-2';
import MenuBarBoldButton from '@/common/components/tiptap/buttons/MenuBarBoldButton.vue';
import MenuBarItalicButton from '@/common/components/tiptap/buttons/MenuBarItalicButton.vue';
import MenuBarUnderlineButton from '@/common/components/tiptap/buttons/MenuBarUnderlineButton.vue';
import MenuBarStrikeButton from '@/common/components/tiptap/buttons/MenuBarStrikeButton.vue';
import MenuBarLinkButton from '@/common/components/tiptap/buttons/MenuBarLinkButton.vue';
import MenuBarNumberedListButton from '@/common/components/tiptap/buttons/MenuBarNumberedListButton.vue';
import MenuBarBulletedListButton from '@/common/components/tiptap/buttons/MenuBarBulletedListButton.vue';
import MenuBarClearButton from '@/common/components/tiptap/buttons/MenuBarClearButton.vue';
import MenuBarColorButton from '@/common/components/tiptap/buttons/MenuBarColorButton.vue';
import MenuBarHighlightButton from '@/common/components/tiptap/buttons/MenuBarHighlightButton.vue';
import MenuBarSizeButton from '@/common/components/tiptap/buttons/MenuBarSizeButton.vue';
import MenuBarAlignmentButton from '@/common/components/tiptap/buttons/MenuBarAlignmentButton.vue';
import {TextEditorToolbarOptions} from '@/constants';

export default {
    name: 'BubbleMenuBar',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editor: {
            type: Editor,
            required: true
        },
        toolbarOptions: {
            type: Array,
            default: () => TextEditorToolbarOptions.default
        }
    },
    computed: {
        hasAlignmentButtons() {
            return ['left', 'center', 'right', 'justify'].some(option => this.toolbarOptions.includes(option));
        },
        tippyOptions() {
            return {
                duration: 100,
                appendTo: () => document.body
            };
        }
    },
    components: {
        BubbleMenu,
        MenuBarBoldButton,
        MenuBarItalicButton,
        MenuBarUnderlineButton,
        MenuBarStrikeButton,
        MenuBarLinkButton,
        MenuBarNumberedListButton,
        MenuBarBulletedListButton,
        MenuBarClearButton,
        MenuBarColorButton,
        MenuBarHighlightButton,
        MenuBarSizeButton,
        MenuBarAlignmentButton
    }
};
</script>
